export default Object.freeze({
  JURISDICTION_NAME: {
    HEADER: 'Jurisdiction Name',
    ACCESSOR: 'name'
  },
  JURISDICTION_TYPE: {
    HEADER: 'Jurisdiction Type',
    ACCESSOR: 'type'
  },
  PAID_LEAVE_TYPE: {
    HEADER: 'Paid Leave Type',
    ACCESSOR: 'type',
    KEY: 'paidLeaveType'
  },
  PAID_LEAVE_TYPES: {
    HEADER: 'Paid Leave Types',
    ACCESSOR: 'type',
    KEY: 'paidLeaveTypes'
  },
  LOCATIONS_AFFECTED: {
    HEADER: 'Locations Affected',
    ACCESSOR: 'locations'
  },
  LOCATION_NAME: {
    HEADER: 'Location Name',
    ACCESSOR: 'name',
    FIELD: 'displayName'
  },
  ADDRESS: {
    HEADER: 'Address',
    ACCESSOR: 'address'
  },
  ADDRESS_1: {
    HEADER: 'Address 1',
    ACCESSOR: 'address1'
  },
  ADDRESS_2: {
    HEADER: 'Address 2',
    ACCESSOR: 'address2'
  },
  CITY: {
    HEADER: 'City',
    ACCESSOR: 'city'
  },
  STATE: {
    HEADER: 'State',
    ACCESSOR: 'state'
  },
  ZIP: {
    HEADER: 'Zip',
    ACCESSOR: 'zip'
  },
  COUNTRY: {
    HEADER: 'Country',
    ACCESSOR: 'country'
  },
  TYPE: {
    HEADER: 'Type',
    ACCESSOR: 'type'
  }
})
